export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}
export function getRole() {
  return getUser()?.roles ?? null;
}
export function hasRole(roleName) {
  try {
    const user = localStorage.getItem("user");
    if (!user) return false;

    const userObj = JSON.parse(user);
    const roles = userObj?.roles;

    return Array.isArray(roles) && roles.includes(roleName);
  } catch {
    return false;
  }
}
